module.exports = __webpack_public_path__ + "img/42227f7.jpg";